import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from "@angular/core";
import { provideRouter, withPreloading, PreloadAllModules } from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { providePrimeNG } from "primeng/config";
import Aura from "@primeng/themes/aura"; // Adjust the import based on the available themes

import { routes } from "./app.routes";
import { loaderInterceptor } from "./shared/components/loader/interceptors/loader.interceptor";
import { authInterceptor } from "./core/interceptors/auth.interceptor";
import { errorInterceptor } from "./core/interceptors/error.interceptor";


import { MessageService } from "primeng/api";
import { RECAPTCHA_V3_SITE_KEY } from "ng-recaptcha";
import { environment } from "@environments/environment";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([
      loaderInterceptor,
      authInterceptor,
      errorInterceptor
    ])), // Registering global loader interceptor here
    MessageService,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: ".app-dark", // Disables dark mode
        },
      },
    }),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.captchaKey, // <--- REPLACE WITH YOUR ACTUAL V3 SITE KEY
    },
  ],
};
